import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail, Phone } from 'lucide-react';
import './Footer.css';

const Footer = () => {


    return (
        <footer className="footer">
            <div className="container footer-grid">
                <div className="footer-brand">
                    <div className="footer-logo">
                        <div className="logo-background" style={{ display: 'inline-flex', padding: '6px 16px', borderRadius: '50px', background: '#fff' }}>
                            <img src="/Logo/logo usable.png" alt="Kodebuild Logo" className="footer-logo-img" />
                        </div>
                    </div>
                    <p className="footer-tagline">Innovative in every Byte</p>
                    <div className="social-links">
                        <a href="https://www.facebook.com/profile.php?id=61564288034490" target="_blank" rel="noopener noreferrer" className="glow-hover"><Facebook size={18} /></a>
                        <a href="https://www.instagram.com/kodebuild?igsh=c3psOThpMWoyM2k5" target="_blank" rel="noopener noreferrer" className="glow-hover"><Instagram size={18} /></a>
                        <a href="https://www.linkedin.com/company/kodebuildtech/" target="_blank" rel="noopener noreferrer" className="glow-hover"><Linkedin size={18} /></a>
                    </div>
                    <div className="footer-emails">
                        <a href="tel:+263777305046" className="footer-email-link">
                            <Phone size={14} />
                            <span>+263 777 305 046</span>
                        </a>
                        <a href="mailto:info@kodebuildtech.com" className="footer-email-link">
                            <Mail size={14} />
                            <span>info@kodebuildtech.com</span>
                        </a>
                        <a href="mailto:kodebuildtech@gmail.com" className="footer-email-link footer-email-alt">
                            <Mail size={14} />
                            <span>kodebuildtech@gmail.com</span>
                        </a>
                    </div>
                </div>

                <div className="footer-col">
                    <h4>Solutions</h4>
                    <ul>
                        <li><Link to="/service/software-engineering">Software Engineering</Link></li>
                        <li><Link to="/service/web-development">Web Development</Link></li>
                        <li><Link to="/service/mobile-applications">Mobile Applications</Link></li>
                        <li><Link to="/service/ai-automation">AI & Automation</Link></li>
                        <li><Link to="/service/digital-transformation">Digital Transformation</Link></li>
                        <li><Link to="/service/cybersecurity">Cybersecurity</Link></li>
                        <li><Link to="/service/cloud-infrastructure">Cloud Infrastructure</Link></li>
                        <li><Link to="/service/systems-integration">Systems Integration</Link></li>
                    </ul>
                </div>

                <div className="footer-col">
                    <h4>Resources</h4>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/about">About Us</Link></li>
                        <li><Link to="/work">Our Work</Link></li>
                        <li><Link to="/contact">Contact Us</Link></li>
                    </ul>
                </div>

                <div className="footer-col">
                    <h4>Company</h4>
                    <ul>
                        <li><Link to="/privacy">Privacy Policy</Link></li>
                        <li><Link to="/terms">Terms of Service</Link></li>
                        <li><Link to="/disclaimer">Disclaimer</Link></li>
                        <li><Link to="/contact">Careers</Link></li>
                        <li><Link to="/contact">Get in Touch</Link></li>
                    </ul>
                </div>

                <div className="footer-bottom">
                    <div className="footer-bottom-content">
                        <p>&copy; {new Date().getFullYear()} Kodebuild. All rights reserved.</p>
                        <div className="footer-legal">
                            <span>Zimbabwe • South Africa • Global</span>
                            <a
                                href="https://hostinger.com?REFERRALCODE=MZKKARURUV3Y"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hostinger-ref-link"
                            >
                                Powered by Hostinger
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
